import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Loading from '../general/Loading';

const EditProduct = ({ setResponse }) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const product = state?.product;
  const inventoryState = state?.inventoryState;
  const [newLoading, setNewLoading] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
const [imageToDelete, setImageToDelete] = useState(null);
const [selectedFiles, setSelectedFiles] = useState([]);

  const [formData, setFormData] = useState({
    productName: '',
    stock: '',
    brandName: '',
    category: '',
    subCategory: '',
    mfgDate: '',
    expDate: '',
    images: [],
    purchasePrice: '',
    mrp: '',
    dynamicPricing: [{ qty: '', price: '' }],
    tax: 'none',
    discountType: '',
    discountGiven: '',
    description: '',
    barcode: '',
    custom: '',
  });

  const [imagePreview, setImagePreview] = useState([]);
  const [imagePreview2, setImagePreview2] = useState([]);

const formatDate = (date) => {
  if (!date) return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return ''; // invalid date check
  return d.toISOString().slice(0, 10); // YYYY-MM-DD
};


  useEffect(() => {
    if (product) {
      setFormData({
        productName: product.name || '',
        stock: product.stock || '',
        brandName: product.brand || '',
        category: product.category || '',
        subCategory: product.sub_category || '',
 mfgDate: formatDate(product.mfg),
      expDate: formatDate(product.exp),        images: [],
        purchasePrice: product.purchase_price || '',
        mrp: product.mrp || '',
        dynamicPricing: product.sell_price ? JSON.parse(product.sell_price) : [{ qty: '', price: '' }],
        tax: product.tax_amount || 'none',
        discountType: product.discount_type || '',
        discountGiven: product.discount_amount || '',
        description: product.description || '',
        barcode: product.barcode || '',
        custom: product.custom || '',
      });

      if (product.image) {
        const previews = product.image.split(',').map(
          (img) => `https://api.hargharmart.com/uploads/${img.trim()}`
        );
        setImagePreview(previews);
      }
    }
  }, [product]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleDynamicPricingChange = (index, field, value) => {
    const updated = [...formData.dynamicPricing];
    updated[index][field] = value;
    setFormData((prev) => ({ ...prev, dynamicPricing: updated }));
  };

  const addDynamicPricingRow = () => {
    setFormData((prev) => ({
      ...prev,
      dynamicPricing: [...prev.dynamicPricing, { qty: '', price: '' }],
    }));
  };

  const removeDynamicPricingRow = (index) => {
    const updated = [...formData.dynamicPricing];
    updated.splice(index, 1);
    setFormData((prev) => ({ ...prev, dynamicPricing: updated }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSubmit = new FormData();
    Object.keys(formData).forEach((key) => {
      if (key === 'images') return;
      if (key === 'dynamicPricing') {
formDataToSubmit.append('dynamicPricing', JSON.stringify(formData.dynamicPricing));
      } else {
        formDataToSubmit.append(key, formData[key]);
      }
    });

    setNewLoading(true);

    try {
      const response = await fetch(`https://api.hargharmart.com/update-product/${product.id}`, {
        method: 'PUT',
        body: formDataToSubmit,
      });

      setNewLoading(false);

      if (response.ok) {
        setResponse({ message: 'Product updated successfully!', status: 'success' });
        setTimeout(() => setResponse(''), 2000);
        navigate('/inventory',  {
  state: {
    inventoryState
  }
});
      } else {
        setResponse({ message: 'Failed to update product.', status: 'error' });
        setTimeout(() => setResponse(''), 2000);
      }
    } catch (error) {
      console.error('Error updating product:', error);
      setNewLoading(false);
    }
  };


const handleFileChange = (e) => {
  const files = Array.from(e.target.files);
  if (files.length > 2) {
    files.splice(2); // Limit to max 2 files
  }
  setSelectedFiles(files);

  // Create previews from files
  const previews = files.map(file => URL.createObjectURL(file));
  setImagePreview2(previews);
};


const handleNewUpload = async (productId) => {
  if (selectedFiles.length === 0) {
    alert("Please select at least one image.");
    return;
  }

  const formData = new FormData();
  selectedFiles.forEach(file => formData.append('images', file));

  setNewLoading(true);
  try {
    const response = await fetch(`https://api.hargharmart.com/update-image/${productId}`, {
      method: 'POST',
      body: formData,
    });

    setNewLoading(false);

    if (response.ok) {
      const data = await response.json();

      if (data.updatedImages) {
        setImagePreview(data.updatedImages);
      }

      setShowUpload(false);
      setSelectedFiles([]);
      setImagePreview2([]);

      setResponse({ message: 'Images uploaded successfully!', status: 'success' });
      setTimeout(() => setResponse(''), 2000);
    } else {
      setResponse({ message: 'Failed to upload images.', status: 'error' });
      setTimeout(() => setResponse(''), 2000);
    }
  } catch (error) {
    console.error("Error uploading images:", error);
    setNewLoading(false);
  }
};


  return (
    <>
      <section className='my-4'>
        <div className="px-4">
          <div className='d-flex justify-content-between'>
            <p className='page-title'>Edit Product: {product?.name}</p>
            <button className='close-btn' onClick={() => navigate('/inventory', {
  state: {
    inventoryState
  }
})}>
              Back to Inventory
            </button>
          </div>

          <form onSubmit={handleSubmit} className='bg-white rounded-2 mt-3 row g-3'>
            {/* Column 1: Basic Info */}
            <div className="col-md-4">
              <label className="profile-label">Product Name</label>
              <input type="text" id="productName" className="product-control" value={formData.productName} onChange={handleChange} required />

              <label className="profile-label mt-3">Brand Name</label>
              <input type="text" id="brandName" className="product-control" value={formData.brandName} onChange={handleChange} />

              <label className="profile-label mt-3">Category</label>
              <input type="text" id="category" className="product-control" value={formData.category} onChange={handleChange} />

              <label className="profile-label mt-3">Subcategory</label>
              <input type="text" id="subCategory" className="product-control" value={formData.subCategory} onChange={handleChange} />


              <label className="profile-label mt-3">Mfg Date</label>
              <input type="date" id="mfgDate" className="product-control" value={formData.mfgDate} onChange={handleChange} />

              <label className="profile-label mt-3">Exp Date</label>
              <input type="date" id="expDate" className="product-control" value={formData.expDate} onChange={handleChange} />

              <label className="profile-label mt-3">Barcode</label>
              <input type="text" id="barcode" className="product-control" value={formData.barcode} onChange={handleChange} />
            </div>

            {/* Column 2: Pricing */}
            <div className="col-md-4">
              <label className="profile-label">Purchase Price</label>
              <input type="number" id="purchasePrice" className="product-control" value={formData.purchasePrice} onChange={handleChange} />

              <label className="profile-label mt-3">MRP</label>
              <input type="number" id="mrp" className="product-control" value={formData.mrp} onChange={handleChange} />

              <label className="profile-label mt-3">Dynamic Pricing</label>
              <br />
{Array.isArray(formData.dynamicPricing) && formData.dynamicPricing.map((item, index) => (
                <div className="d-flex mb-2" key={index}>
                  <input
                    type="number"
                    className="product-control me-2"
                    placeholder="Qty"
                    value={item.qty}
                    onChange={(e) => handleDynamicPricingChange(index, 'qty', e.target.value)}
                  />
                  <input
                    type="number"
                    className="product-control me-2"
                    placeholder="Price"
                    value={item.price}
                    onChange={(e) => handleDynamicPricingChange(index, 'price', e.target.value)}
                  />
                  <button type="button" className="close-btn px-2 py-0" onClick={() => removeDynamicPricingRow(index)}>×</button>
                </div>
              ))}
              <button type="button" className="edit-btn px-3 py-1" onClick={addDynamicPricingRow}>+ Add</button>

<br/>
              <label className="profile-label mt-3">Tax</label>
              <select id="tax" className="product-control" value={formData.tax} onChange={handleChange}>
                <option value="none">None</option>
                <option value="GST 0">GST 0%</option>
                <option value="GST 0.25">GST 0.25%</option>
                <option value="GST 3">GST 3%</option>
                <option value="GST 5">GST 5%</option>
                <option value="GST 12">GST 12%</option>
                <option value="GST 18">GST 18%</option>
                <option value="GST 28">GST 28%</option>
              </select>

              <label className="profile-label mt-3">Discount Type</label>
              <select id="discountType" className="product-control" value={formData.discountType} onChange={handleChange}>
                                <option value="">Choose...</option>
                <option value="percent">Percent %</option>
                <option value="amount">Amount ₹</option>
              </select>

              <label className="profile-label mt-3">Discount Given</label>
              <input type="number" id="discountGiven" className="product-control" value={formData.discountGiven} onChange={handleChange} />
            </div>

            {/* Column 3: Dates, Discount, Description */}
            <div className="col-md-4">

              <label className="profile-label">Description</label>
              <textarea id="description" rows="3" className="product-control" value={formData.description} onChange={handleChange}></textarea>

              <label className="profile-label mt-3">Stock</label>
              <input type="number" id="stock" className="product-control" value={formData.stock} onChange={handleChange} />

              <label className="profile-label mt-3">Custom</label>
              <input type="text" id="custom" className="product-control" value={formData.custom} onChange={handleChange} />

              <label className="profile-label mt-3">Product Image</label>
          <div className="d-flex justify-content-center flex-wrap gap-2">
            {imagePreview.length > 0 ? (
              imagePreview.map((src, i) => (
                <div className='position-relative'>
                  <span className='position-absolute px-2 text-danger fs-5 cursor-pointer' onClick={() => {
          setImageToDelete(src);
          setShowDelete(true);
          console.log(imageToDelete);
        }}><i class="fa-solid fa-circle-minus"></i></span>
                <img key={i} src={src} alt={`img-${i}`} style={{ height: 120}} /></div>
              ))
            ) : (
              <p>No image available.</p>
            )}
          </div>
            <div className='text-center fs-4 text-primary cursor-pointer' onClick={() => setShowUpload(true)}><i class="fa-solid fa-circle-plus"></i></div>

              </div>


        <div className="col-12 mt-4">
          <button type="submit" className="edit-btn float-end">Update Product</button>
        </div>
      </form>
    </div>
  </section>

{showUpload && (
  <section className="detail-dialog animate__animated animate__zoomIn px-2">
    <div className='detail-dialog-inner text-center col-lg-4 col-11 mx-auto px-lg-5 py-lg-5 px-3 py-3'>

      <p className='page-title fs-6'>Upload New Images</p>
      <p className='profile-label w-100'>Max 2 Images are Allowed*</p>

      {/* <label className="profile-label mt-3">Product Images (Max 2)</label> */}
      <input
        type="file"
        accept="image/*"
        multiple
        onChange={handleFileChange}
        className="product-control"
      />

      {/* Show previews of selected images */}
      <div className="d-flex justify-content-center flex-wrap gap-2 my-3">
        {imagePreview2.length > 0 ? (
          imagePreview2.map((src, i) => (
            <img key={i} src={src} alt={`preview-${i}`} style={{ height: 120 }} />
          ))
        ) : (
          ''
        )}
      </div>

      <button className='edit-btn' onClick={() => handleNewUpload(product.id)}>Yes</button>&nbsp;&nbsp;
<button className='close-btn' onClick={() => setShowUpload(false)}>No</button>


    </div>
  </section>
)}


{showDelete && (
  <section className="detail-dialog animate__animated animate__zoomIn px-2">
    <div className='detail-dialog-inner text-center col-lg-4 col-11 mx-auto px-lg-5 py-lg-5 px-3 py-3'>
        {/* <p className='page-title fs-6'>Confirm Delete</p> */}
<p className='page-title fs-6'>Want to Delete this Image?</p>

      <div className="d-flex justify-content-center mb-3">
        <img src={imageToDelete} alt="to-delete" style={{ height: 120 }} />
      </div>
 
      <button
        className='edit-btn me-2'
        onClick={async () => {
          setNewLoading(true);
          try {
            // Extract image filename from URL
            const imageName = imageToDelete.split('/').pop();

            const response = await fetch(`https://api.hargharmart.com/delete-image/${product.id}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ imageName }),
            });

            setNewLoading(false);
            setShowDelete(false);

            if (response.ok) {
              setResponse({ message: 'Image deleted successfully!', status: 'success' });

              // Remove deleted image from preview
              setImagePreview((prev) => prev.filter(img => img !== imageToDelete));
              setTimeout(() => setResponse(''), 2000);
            } else {
              setResponse({ message: 'Failed to delete image.', status: 'error' });
              setTimeout(() => setResponse(''), 2000);
            }
          } catch (error) {
            console.error('Error deleting image:', error);
            setNewLoading(false);
            setShowDelete(false);
          }
        }}
      >
        Yes
      </button>
      <button className='close-btn' onClick={() => setShowDelete(false)}>No</button>
    </div>
  </section>
)}


  {newLoading && <Loading setLoading={setNewLoading} />}
</>
);
};

export default EditProduct;
